import React, { Component } from "react";
import "./CreditScreen.scss";
import _Content from "../../static/data/content.json";
import { groupBy } from "../Services/Array";

const __Categories__ = groupBy(_Content, g => g.ImageCredit);

export default class CreditScreen extends Component {
    constructor() {
        super();
        this.renderCredits = this.renderCredits.bind(this);
        this.state = {}
    }
    renderCredits() {
        let credits = [];
        var i = 0;
        __Categories__.forEach(obj => {
            credits.push(<InnerCreditHead key={i} ImageCredit={obj[0].ImageCredit} />);
            i++;
            obj.map((item, index) => {
                credits.push(<InnerCredit key={i} index={index} {...item} />);
                i++;
            })
        })
        return credits;
    }
    render() {
        return (
            <section className="section section-credits">
                <div className="credit-header">
                    <div className="close" onClick={this.props.toggleCreditScreen}></div>
                </div>
                <div className="content">
                    {this.renderCredits()}
                </div>
            </section>
        )
    }
}

const InnerCreditHead = props => {
    if(!props.ImageCredit)  {
        return <div></div>
    }
    return (
        <div className="credit-head">
            צילום: {props.ImageCredit}
        </div>
    )
}
const InnerCredit = props => {
    if(!props.ImageCredit)  {
        return <div></div>
    }
    return (
        <div className="credit-spec">
            {props.Category}, {props.Name}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Components/Screen/CreditScreen.jsx